import React, { ReactNode } from 'react'
import ErrorComponent from '../pages/bad-request';
import { staticHomePageData } from 'app/homePageData';

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught in ErrorBoundary:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorComponent 
            homePageData={staticHomePageData} 
            popularSearches={false} 
            dynamicFooterData="" />
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
